
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Es hat lange gedauert. In den letzten zwei Jahrzehnten haben die Kantone auf Geheiss des Bundes spezielle Gefahrenkarten erstellt. Sie zeigen, welche Gebiete von Naturgefahren bedroht sind. Konkret durch Hochwasser, Lawinen, Rutschungen und Sturzprozesse.`}</p>
    <p>{`Für Lawinen und Hochwasser ist inzwischen fast die gesamte Fläche der Schweiz erfasst. Alle Kantone haben ihre entsprechenden Karten auch online zugänglich gemacht.`}<br /><br /><b>{`Was fehlt, ist ein schweizweit einheitliches Tool. Ein solches haben nun das Datenteam und das Interaktiv-Team von Tamedia erstellt.`}</b>{` Sie können damit gezielt nach Adressen suchen oder Ihr Haus und Ihre Nachbarschaft auf Gefahrenbereiche prüfen.`}</p>
    <p>{`Naturgefahren betreffen in der Schweiz nicht nur die Bergregionen. Das zeigt sich insbesondere bei den Hochwassern. Auch im dicht bebauten Mittelland liegen grosse Flächen in Gefahrengebieten. Die Auswertung der Karte hat ergeben, dass hier schätzungsweise eine Million Menschen wohnen. 65’000 von ihnen in Bereichen mit dem höchsten Risiko. Und mit dem Klimawandel wird die Zahl der Extremereignisse in der Schweiz zunehmen. Gefahrenkarten werden in den meisten Kantonen nur für die Siedlungsgebiete erstellt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;